import { useLocation, useNavigate } from "react-router-dom";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { infoHeadTitleList } from "./parts";
import { Box, Link } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkButton from "../../components/atoms/TkButton";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpAPI_CON004 } from "./api/request";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { TkRouteContext } from "../../context/tkRouteContext";
import _ from "lodash";

/**
 * SCRC040103 「俸給の調整額」登録済及び登録非該当手当一覧
 * このコンポーネントはinfoHeadTitleListをレンダリングします。
 * @return SCRC040103 「俸給の調整額」登録済及び登録非該当手当一覧
 */
const SCRC040103 = () => {
  const navigate = useNavigate();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: globalState, setState } = useContext(GlobalContext);
  const stepper = [
    "「俸給の調整額」対象手当一覧",
    "「俸給の調整額」登録内容入力",
    "機構へ提出",
  ];
  const [bodyList, setbodyList] = useState<any[]>([]);

  const location = useLocation();
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const isDaikosha =
    globalState.authInfo?.userType ===
    authorityUserType.userTypeNumber.DAIKOSHA;
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  async function openingScreen() {
    try {
      const res = await httpAPI_CON004({
        contractorNo:
          globalState.authInfo?.userType ===
          authorityUserType.userTypeNumber.KIKO
            ? businessState?.common?.contractorNo
            : globalState.authInfo?.contractorNo,
      });
      if (res.resultCd === "I0000") {
        const screenList = [];
        for (let i = 0; i < res.allowanceList?.length!; i++) {
          const data = [
            {
              children: (
                <Link
                  onClick={() =>
                    infoClick(
                      res.allowanceList![i].applyId!,
                      res.allowanceList![i].allowanceSerialNo!
                    )
                  }
                  className="tkLikeLink"
                >
                  {res.allowanceList![i].allowanceName}
                </Link>
              ),
            },
            {
              children: res.allowanceList![i].salaryRegulations
                ? "第" + res.allowanceList![i].salaryRegulations + "条"
                : "",
            },
            {
              children: res.allowanceList![i].latestApplyStatus,
            },
            {
              children: res.allowanceList![i].rejectionReason,
            },
          ];
          if (res.allowanceList![i].facilityList) {
            const facilitiesInfo = res
              .allowanceList![i].facilityList!.map(
                (facility) =>
                  (facility.facilityNo ?? "") +
                  ":" +
                  (facility.facilityName ?? "")
              )
              .join("、");

            data.push({
              children: facilitiesInfo,
            });
          }
          screenList.push(data);
        }
        setbodyList(screenList);
        setState({
          ...globalState,
          errorMsgId: "",
        });
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }
  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addClick = () => {
    setBusinessState({
      ...businessState,
      job_07: {
        ...businessState.job_07,
        applyId: undefined,
      },
    });
    navigate("/SCRC040004");
  };

  const infoClick = (applyId: number, allowanceHisSerialNo: number) => {
    setBusinessState({
      ...businessState,
      job_07: {
        ...businessState.job_07,
        applyId: applyId,
      },
    });
    navigate("/SCRC040004", {
      state: {
        applyId: applyId,
        allowanceHisSerialNo,
      },
    });
  };

  return (
    <Box data-testid="SCRC040103PageForTest" className="tkSCRC040103">
      <TkStepper steps={stepper} activeStep={0} />
      <Box className="tkInfoDisplay">
        <TkInfoManual children={labelids.labelid.LBLC040103_01} rule={"\\n"} />
        <Box className="tkTopButton">
          <TkButton onClick={addClick} disabled={isDaikosha}>
            {"追加登録の申請画面へ"}
          </TkButton>
        </Box>
      </Box>
      {globalState.authInfo?.userType ===
        authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <TkTable headList={infoHeadTitleList} bodyList={bodyList} />
      <Box className="tkBtn">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRC040103;
